import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import styles from './index.module.css';
import NotFound from "../components/NotFound";
import Footer from "../components/Footers";
import ExamControllerSidebar from "../components/Sidebar/ExamControllerSidebar";
import ExamControllerRoutes from "../routes/ExamControllerRoutes";
import EntityAdminHeader from "../components/Header/EntityAdminHeader";

const ExamControllerLayout = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    return (
        <div className={styles.appContainer}>
            <ExamControllerSidebar  isSidebarOpen={isSidebarOpen} closeSidebar={closeSidebar}/>
            <div className={styles.main}>                
            <EntityAdminHeader toggleSidebar={toggleSidebar}/>
            <div className={styles.content}>
                <Routes>
                    {ExamControllerRoutes.map((prop, key) => (
                        <Route path={prop.path} element={prop.element} key={key} />
                    ))}
                    <Route path="*" element={<div><NotFound/></div>} />
                </Routes>
                <Footer/>        
            </div>    
            </div>
        </div>
    );
};

export default ExamControllerLayout;
